// extracted by mini-css-extract-plugin
export default {"modal":"AddInConfirmOutlineInsert_modal__zzZt4","body":"AddInConfirmOutlineInsert_body__auAgz"};